/**
Copyright (c) 2022–2026 Podstack.ai
All rights reserved.
Proprietary and Confidential.
Unauthorized copying of this file, via any medium, is strictly prohibited.
This file is part of the Podstack Platform.
*/

// NFS volume names become Kubernetes volume names ("nfs-<name>", lowercased by
// the platform), which must be RFC 1123 DNS labels: letters, digits and
// hyphens only, starting and ending with an alphanumeric, max 63 chars
// including the "nfs-" prefix.
const MAX_VOLUME_NAME_LENGTH = 59;
const VOLUME_NAME_PATTERN = /^[a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?$/;

/**
 * Validates an NFS volume name. Returns an error message, or null if valid.
 */
export function validateVolumeName(name: string): string | null {
  const trimmed = name.trim();

  if (!trimmed) {
    return 'Volume name is required';
  }
  if (trimmed.length > MAX_VOLUME_NAME_LENGTH) {
    return `Volume name must be at most ${MAX_VOLUME_NAME_LENGTH} characters`;
  }
  if (trimmed.includes('.')) {
    return 'Volume name must not contain dots - use hyphens instead (e.g. "ltx-2-3", not "ltx-2.3")';
  }
  if (!VOLUME_NAME_PATTERN.test(trimmed)) {
    return 'Volume name can only contain letters, numbers, and hyphens, and must start and end with a letter or number';
  }
  return null;
}
